import { getCookie, setCookie } from '@atlassian/browser-storage-controls/cookie-controls';

export const SINGLE_INSTRUMENTATION_ID_IS_NOT_SET = 'SINGLE_INSTRUMENTATION_ID_IS_NOT_SET';

export const getSingleInstrumentationIDCookieName = (uniqueCookieFeatureName: string) =>
	`AI_INSTRUMENTATION_FEATURE_ID_${uniqueCookieFeatureName}`;

export const setSingleInstrumentationIDCookie = (
	uniqueCookieFeatureName: string,
	nextSingleInstrumentationID: string,
) =>
	setCookie(
		getSingleInstrumentationIDCookieName(uniqueCookieFeatureName),
		nextSingleInstrumentationID,
		{
			expires: 7,
			domain: location.hostname,
			sameSite: 'strict',
		},
	);

export const readSingleInstrumentationIDCookie = (uniqueCookieFeatureName: string): string =>
	getCookie(getSingleInstrumentationIDCookieName(uniqueCookieFeatureName)) ||
	SINGLE_INSTRUMENTATION_ID_IS_NOT_SET;
